import { Tabs } from 'react-tabs';
import styled from 'styled-components';

export const CustomTabs = styled(Tabs)`
  width: 100%;
`;
